import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useSystemStateHooks } from '../../system'
import { Area, Employee } from '../state/types'

export const useEmployeeBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildEmployee = (data: Data2) => {
        const { id = newId(), name, identifier, area, email, address, phone, branchId, archived } = data
        const employee: Employee = {
            companyId: companyId!,
            id: id! as string,
            name: name! as string,
            identifier: identifier as O<number>,
            area: area! as Area,
            email: email! as string,
            phone: phone as O<number>,
            address: address as O<string>,
            branchId: branchId! as string,
            archived: !!archived
        }

        return employee
    }

    return {
        buildEmployee
    }
}
